/**
 * `53` — *When {status, columnId} changes* (any value). The root of the two-node
 * "changes … to X" / "changes … from X to Y" recipes: the comparison lives in conditions `45`
 * and `48`, which read `columnValue` / `prevStatusValue` from **this** node's results.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { columnRefSchema, labelIndexOf } from '../values.js';
export const statusChangesParams = z.object({ columnId: columnRefSchema });
export const statusChangesTrigger = defineTrigger({
    id: '53',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When {status, columnId} changes',
    paramsSchema: statusChangesParams,
    requiredColumnTypes: ['status'],
    subscribes: ['cell.changed'],
    references: (params) => [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    matches(event, params) {
        if (event.payload.columnId !== params.columnId.columnId)
            return false;
        return labelIndexOf(event.payload.value) !== labelIndexOf(event.payload.previousValue);
    },
    outputs(event) {
        return {
            itemId: event.itemId,
            boardId: event.boardId,
            columnId: event.payload.columnId,
            columnValue: labelIndexOf(event.payload.value),
            prevStatusValue: labelIndexOf(event.payload.previousValue),
        };
    },
});
//# sourceMappingURL=53.js.map